import {
	RawGenderPerRegionData,
	RawMkfDomenData,
	RawMkfPrefixData,
	RawPatientsAges,
	RawPerformanceSatisfactionChangesData,
	RawSectionData,
	RawSectionRatingsAverageData,
	RawSubsectionData,
} from './types';
import { privateApi } from '../private-api';
import { PerformanceSatisfactionChangesReport } from 'features/charts/performance-satisfaction-changes-report';

export const chartsApi = privateApi.injectEndpoints({
	endpoints: (builder) => ({
		patientsAges: builder.query<RawPatientsAges[], null>({
			query() {
				return {
					url: 'report/charts/patients-ages',
					method: 'GET',
					credentials: 'include',
				};
			},
			serializeQueryArgs: ({ endpointName, queryArgs }) => {
				const user = localStorage.getItem('userToken') || 'anon';
				return `${endpointName}|${user}|${JSON.stringify(queryArgs)}`;
			},
			keepUnusedDataFor: 0,
			providesTags: ['Charts'],
			transformResponse: (data: RawPatientsAges[]) =>
				data.slice().sort((a, b) => {
					const aMin = parseInt(a.ageGroup.split('-')[0], 10);
					const bMin = parseInt(b.ageGroup.split('-')[0], 10);
					return aMin - bMin;
				}),
		}),
		sectionsData: builder.query<RawSectionData[], null>({
			query: () => ({
				url: 'report/charts/sections',
				method: 'GET',
				credentials: 'include',
			}),
			serializeQueryArgs: ({ endpointName, queryArgs }) => {
				const user = localStorage.getItem('userToken') || 'anon';
				return `${endpointName}|${user}|${JSON.stringify(queryArgs)}`;
			},
			keepUnusedDataFor: 0,
			providesTags: ['Charts'],
		}),
		subsectionData: builder.query<RawSubsectionData[], null>({
			query: () => ({
				url: 'report/charts/subsections',
				method: 'GET',
				credentials: 'include',
			}),
			serializeQueryArgs: ({ endpointName, queryArgs }) => {
				const user = localStorage.getItem('userToken') || 'anon';
				return `${endpointName}|${user}|${JSON.stringify(queryArgs)}`;
			},
			keepUnusedDataFor: 0,
			providesTags: ['Charts'],
		}),
		sectionsRatingsAverageData: builder.query<RawSectionRatingsAverageData[], null>({
			query: () => ({
				url: 'report/charts/sections-average-ratings',
				method: 'GET',
				credentials: 'include',
			}),
			serializeQueryArgs: ({ endpointName, queryArgs }) => {
				const user = localStorage.getItem('userToken') || 'anon';
				return `${endpointName}|${user}|${JSON.stringify(queryArgs)}`;
			},
			keepUnusedDataFor: 0,
			providesTags: ['Charts'],
		}),
		mkfPrefixData: builder.query<RawMkfPrefixData[], null>({
			query: () => ({
				url: 'report/charts/mkf-prefix-mentions',
				method: 'GET',
				credentials: 'include',
			}),
			serializeQueryArgs: ({ endpointName, queryArgs }) => {
				const user = localStorage.getItem('userToken') || 'anon';
				return `${endpointName}|${user}|${JSON.stringify(queryArgs)}`;
			},
			keepUnusedDataFor: 0,
			providesTags: ['Charts'],
		}),
		mkfDomenData: builder.query<RawMkfDomenData[], null>({
			query: () => ({
				url: 'report/charts/mkf-domain-mentions',
				method: 'GET',
				credentials: 'include',
			}),
			serializeQueryArgs: ({ endpointName, queryArgs }) => {
				const user = localStorage.getItem('userToken') || 'anon';
				return `${endpointName}|${user}|${JSON.stringify(queryArgs)}`;
			},
			keepUnusedDataFor: 0,
			providesTags: ['Charts'],
		}),

		performanceSatisfactionChangesData: builder.query<RawPerformanceSatisfactionChangesData[], null>({
			query: () => ({
				url: 'report/charts/performance-satisfaction-changes',
				method: 'GET',
				credentials: 'include',
			}),
			serializeQueryArgs: ({ endpointName, queryArgs }) => {
				const user = localStorage.getItem('userToken') || 'anon';
				return `${endpointName}|${user}|${JSON.stringify(queryArgs)}`;
			},
			keepUnusedDataFor: 0,
			providesTags: ['Charts'],
		}),
		genderPerRegionData: builder.query<RawGenderPerRegionData[], null>({
			query: () => ({
				url: 'report/charts/gender-per-region',
				method: 'GET',
				credentials: 'include',
			}),
			serializeQueryArgs: ({ endpointName, queryArgs }) => {
				const user = localStorage.getItem('userToken') || 'anon';
				return `${endpointName}|${user}|${JSON.stringify(queryArgs)}`;
			},
			keepUnusedDataFor: 0,
			providesTags: ['Charts'],
		}),
	}),
});
export const {
	usePatientsAgesQuery,
	useSectionsDataQuery,
	useSubsectionDataQuery,
	useSectionsRatingsAverageDataQuery,
	useMkfPrefixDataQuery,
	useMkfDomenDataQuery,
	usePerformanceSatisfactionChangesDataQuery,
	useGenderPerRegionDataQuery,
} = chartsApi;
